// extracted by mini-css-extract-plugin
module.exports = {"header":"CircleButton_header_36jYo","circle":"CircleButton_circle_rqvKx","faStyle":"CircleButton_faStyle_2wd6k","borderRed":"CircleButton_borderRed_2aAfH"};